// 推送渠道静态配置：渠道元信息 + 渠道 tab
// 供「推送渠道管理」弹窗与订阅弹窗等复用；接口只下发渠道实例与绑定状态
import feishuIcon from '@/assets/icon/icon-feishu.svg'
import qiweiIcon from '@/assets/icon/icon-qiwei.svg'
import dingdingIcon from '@/assets/icon/icon-dingding.svg'
import weixinIcon from '@/assets/icon/icon-weixin.svg'

// channelType 为后端渠道枚举，见 @/api/new-agent/channels.js：1-钉钉 2-微信 3-企微 4-飞书
export const CHANNEL_META = {
  1: { name: '钉钉', description: '通过钉钉扫码连接机器人，接收和回复消息。', icon: dingdingIcon },
  2: { name: '微信', description: '通过微信扫码连接机器人，接收和回复消息。', icon: weixinIcon },
  3: { name: '企微', description: '通过企微扫码连接机器人，接收和回复消息。', icon: qiweiIcon },
  4: { name: '飞书', description: '通过飞书扫码连接机器人，接收和回复消息。', icon: feishuIcon }
}

// 渠道 tab，icon 为 iconfont 类名
// value 与订阅弹窗的 targetType 对齐：1-单聊 2-群聊
export const CHANNEL_TAB_OPTIONS = [
  { value: 1, label: '私信渠道', icon: 'icon-chat-2-line' },
  { value: 2, label: '群聊渠道', icon: 'icon-discuss-line' }
]

// 私信渠道固定展示顺序，取值与 CHANNEL_META 的 key 一致
const PRIVATE_CHANNEL_TYPES = [2, 3, 1, 4]

// 是否是真正的绑定成功
const isChannelBound = (item) => item.bindingStatus === 2 && !!item.externalId

// 有渠道记录（下发了 bindingStatus）但还没有 externalId：扫码已确定连接，
// 只差解析 External ID，绑定可以直接从第 2 步开始
const canResumeBinding = (item) => item.bindingStatus === 2 && !item.externalId

/**
 * 私信渠道列表接口返回项 → 展示项
 * 按固定顺序对齐 channelType、补上渠道元信息，并算出绑定状态
 * @param {Array} list getChannelsList 的 result
 */
export const toPrivateChannelList = (list) => {
  const itemMap = new Map((list || []).map((item) => [item.channelType, item]))
  return PRIVATE_CHANNEL_TYPES.map((type) => {
    const item = itemMap.get(type) || {}
    return {
      type,
      ...CHANNEL_META[type],
      // 渠道实例 id 由接口下发，解绑与解析 External ID 都需要回传
      id: item.id,
      bindingStatus: item.bindingStatus,
      bound: isChannelBound(item),
      // resumable 为 true 时绑定弹窗跳过扫码，直接从第 2 步开始
      resumable: canResumeBinding(item)
    }
  })
}
